import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { view as Loading } from "./components/loading";
import { view as Login } from "./login";
import { view as Home } from "./pages";
import { Result, Button, Row, Col } from "antd";
import VedicLogo from "./components/images/vedic_logo.png";

const PageNotFound = () => {
  return (
    <>
      <Row
        type="flex"
        justify="space-around"
        align="middle"
        style={{
          backgroundSize: "cover",
          backgroundColor: "#039BE5",
          backgroundRepeat: "no-repeat",
          height: "100%"
        }}
      >
        <Col xs={24} sm={24} md={24} lg={10} xl={10} style={{ padding: 10 }}>
          <div
            style={{
              padding: "25px",
              textAlign: "center"
            }}
          >
            <img style={{ marginBottom: 20 }} src={VedicLogo}></img>
            <Result
              status="404"
              title="404"
              subTitle="Sorry, the page you visited does not exist."
              style={{ color: "white", fontSize: "50px" }}
              extra={
                <a href="/">
                  <Button style={{background:'#001529'}} type="primary">Go Home</Button>
                </a>
              }
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

const App = () => {
  return (
    <>
      <Loading />
      <Switch>
        <Route path="/" component={Login} exact />
        <Route path="/login" component={Login} />
        <Route path="/home" component={Home} />
        <Route path="*" component={PageNotFound} />
      </Switch>
    </>
  );
};

// const App = props => {};

export default App;
